import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

type DmsState = CommonTableState;

const initialState: DmsState = {
    tableState: {
        resetIndicator: 0,
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        columnVisibility: {
            attachmentType: false,
            attachmentPath: false,
            filesize: false,
            creator: false,
            created: false,
            modified: false,
            description: false,
        },
        columnOrder: [
            "ownerId",
            "ownerType",
            "version",
            "name",
            "creator",
            "description",
            "created",
            "modified",
            "attachmentType",
            "filesize",
            "attachmentPath",
            "mrt-row-actions",
        ],
        density: "compact",
    },
};

export const dmsSlice = createSlice({
    name: "dms",
    initialState: initialState,
    reducers: {
        updateDmsTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

// Action creators are generated for each case reducer function
export const {updateDmsTableState} = dmsSlice.actions;

export default dmsSlice.reducer;
